<template>
    <div class="body">
        <div v-show="ReportData.plansLab=='成长校准者'">
            <p class="p1" style="padding-top: 8vh;">🧭 方向在心，节奏在手</p>
            <p class="p5">你主动为自己定制学习计划，</p>
            <p class="p6">让成长不再随波逐流，而是有章可循。</p>
            <p class="p7">你是一位 <a class="highlight" style="font-size: 24px;">{{ ReportData.plansLab }}</a> </p>
            <p class="p6">你不是随波逐流的学习者，</p>
            <p class="p6">而是会不断调整方向的成长型学习者。</p>
            <p class="p7">一年 <a class="highlight" style="font-size: 24px;">3</a> 次 主动定制学习计划，</p>
            <p class="p6" style="width: 90%;">说明你始终在思考：“什么，才真正对我有用？”</p>
        </div>
        <div v-show="ReportData.plansLab=='阶段型规划者'">
            <p class="p1" style="padding-top: 8vh;">🎯 学习，由你定义</p>
            <p class="p5">你为自己规划学习路径，</p>
            <p class="p6">在主动选择中，稳步前行。</p>
            <p class="p7">你是一位 <a class="highlight" style="font-size: 24px;">{{ ReportData.plansLab }}</a> </p>
            <p class="p6">你会根据阶段目标，</p>
            <p class="p6">为自己重新规划学习路线。</p>
            <p class="p7">一年 <a class="highlight" style="font-size: 24px;">2</a> 次 学习计划定制，</p>
            <p class="p6">是对成长节奏的清醒掌控。</p>
        </div>
        <div v-show="ReportData.plansLab=='稳定前行者'">
            <p class="p1" style="padding-top: 8vh;">🌱 懂规划的人，走得更远</p>
            <p class="p5">你愿意为未来预留时间，</p>
            <p class="p6">让学习成为长期投入，而非一时冲动。</p>
            <p class="p7">你是一位 <a class="highlight" style="font-size: 24px;">{{ ReportData.plansLab }}</a> </p>
            <p class="p6">你选择了一条学习路径，</p>
            <p class="p6">并坚持走下去。</p>
            <p class="p7">专注，本身就是一种难得的能力。</p>
        </div>
    </div>
</template>

<script>
export default {
  props: [ "ReportData"],
  data() {
      return {
      }
  },
}
</script>

<style scoped>
.body {
  background: url("../../assets/25October/logo.png") right  top  no-repeat,
              /* url("../../assets/25May/icon.png") 49% calc(100% + 50px) no-repeat, */
              url("../../assets/25Year/bg.png")  no-repeat;
  background-size:100% 100%,cover;
  width: 100%;
  height: 100vh;
}
.p1,.p2, .p3, .p4 {
  width: 88%;
  margin: 0 auto;
  text-align: left;
  font-size: 18px;
  color: #fff;
  font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.highlight {
  font-size: 30px;
  color: purple;
  text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
  font-weight: bolder;
  font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}

.p5, .p6, .p7, .p8{
  width: 88%;
  margin: 0 auto;
  text-align: left;
  font-size: 16px;
  color: #fff;
  font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}

.p5, .p7{
  margin-top: 20px;
}
@media screen and (min-width: 786px) {
.body {
  background: 
              url("../../assets/25Year/pcbg.jpg")  no-repeat;
  background-size:cover;
  width: 100%;
  height: 100vh;
}
.p1,.p2, .p3, .p4 {
  width: 80%;
  margin: 0 auto;
  text-align: center;
  font-size: 25px;
  color: #fff;
  font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.highlight {
  font-size: 26px;
  color: purple·;
  text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
  font-weight: bolder;
  font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}

.p5, .p6, .p7, .p8{
  margin:0 auto;
  text-align: center;
  font-size: 20px;
  width: 92%;
}

.p5, .p7{
  margin-top: 20px;
}
}
</style>